import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../shared/config/app-config';
import { CareconformationComponent } from '../careconformation/careconformation.component';
import { PatientService, ShowHideInput, User, UserService } from '../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-carepassword',
  templateUrl: './carepassword.component.html',
  styleUrls: ['./carepassword.component.css']
})
export class CarepasswordComponent implements OnInit {
  public timealert = environment.timelimit;
  clientlog: any;
  myDiv: any;
  openErroModel: any;
  modalRef: BsModalRef;
  @ViewChild(ShowHideInput) input: ShowHideInput;
  @ViewChild('erroModal') erroModal: ElementRef;
  respass: string;
  show = false;
  public imageURL: string;
  public currentUser: User;
  isSubmitting = false;
  public params: any;
  public pasd: any = {};
  newonepassword = '';
  newtwopassword = '';
  public apiurl: any = environment.api_url;
  errormsgpass = '';
  @ViewChild('popvaild') testModal: TemplateRef<any>;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-sm',
      backdrop: 'static'
    });
    this.movable()
  }
  constructor(
    private activeroute: ActivatedRoute,
    private routers: Router,
    private userservice: UserService,
    private modalService: BsModalService,
    private dialog: MatDialog,
    private toast: ToastrService,
    private patientservice: PatientService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(userservice.defaultLang); 
    this.activeroute.params.subscribe(params => {
      this.params = params;
    });
    // ////console.log("parm",this.params)
  }

  ngOnInit() {

    this.userservice.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.item) {
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        } else
          this.imageURL = environment.cloudeImageURL;
      }
    )



    // ////console.log(this.currentUser) */
    // ////console.log("params",this.params.name)

    this.userservice.getranidcheck(this.params.name)
      .subscribe(
        data => {
          if (data.userInfo.status == "success") {
            this.clientlog = data.userInfo.userImage
            this.userservice.logAudit("validateuserbyrandid", 0).subscribe(data => { })

          } else {
            this.respass = "Not a vaild ID & try again!!";
            this.dialog.open(CareconformationComponent, { hasBackdrop: true, disableClose: true });
          }
        })
    //this.getlog()
  }


  getlog() {
    this.userservice.getclientlogo(this.params.name)
      .subscribe(
        data => {
          this.clientlog = data.clientLogoPath;
        }
      )
  }

  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }
  openModalc(passcha) {
    //////console.log(passcha);
    this.modalRef = this.modalService.show(passcha, {
      class: 'modal-sm',
      backdrop: 'static'
    })
    this.movable()
  }

  passwordmatch(ed) {
    //////console.log('Valuessss:' , ed.value,this.pasd)
    let patvalue = {
      "randId": this.params.name,
      "newpswd": ed.value.newonepassword
    }
    if (ed.value.newonepassword == ed.value.newtwopassword) {
      this.patientservice.passchange(patvalue)
        .subscribe(
          data => {
            if ((data.message.toLowerCase()) == 'true') {
              this.toast.success(this.userservice.translateText('patient_portal.display_messages.add_message'));
              this.userservice.logAudit('getUserPassWordUpdate', 0).subscribe(data => { })
              this.routers.navigate([`/questions1/${this.params.name}`])
            } else {
              this.toast.error(this.userservice.translateText('patient_portal.display_messages.something_went_wrong'))


            }
          })

    }
    else {
      this.toast.error(this.userservice.translateText('patient_portal.display_messages.new_password_mismatch'));

    }
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  getFullYear() {
    return new Date().getFullYear();
  }
}
